import type { ReactNode } from 'react';

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: Props): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      {icon ? <div className="text-text-mute">{icon}</div> : null}
      <h3 className="text-base font-medium text-text">{title}</h3>
      {description ? (
        <p className="text-sm text-text-dim max-w-md">{description}</p>
      ) : null}
      {action}
    </div>
  );
}
